import * as React from "react";
import { RaiseColors, Typography, makeStyles } from "client/componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    drawerLabel: {
      marginBottom: "8px",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  };
});
var DrawerLabel = function DrawerLabel(_ref) {
  var appendIcon = _ref.appendIcon,
    children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.drawerLabel,
    children: [/*#__PURE__*/_jsx(Typography, {
      weight: "medium",
      color: RaiseColors.glacier2400,
      children: children
    }), appendIcon]
  });
};
export default DrawerLabel;